<template>
  <div style="margin-top: 60px">
    <!-- 轮播-->
    <swiper :options="swiperOption" ref="mySwiper" class="swiper-container-lunbo" v-if='picItems.length>0'>
      <!-- slides -->
      <swiper-slide v-for="item in picItems">
        <img :src="item.img" alt="" style="width: 100%;height: 100%" onerror="src='../static/resource/errorpic.png'"
             @click="ifturntonewpage(item.id,item.hL,item.lU)"/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- 主体内容-->
    <div class="content">
      <!-- 资讯热点模块-->
      <div class="news" v-show="ifShowNews">
        <div>
          <div style="float: left">
            <p class="newspo">资讯热点</p>
            <p class="newspt">news</p>
          </div>
          <router-link class="router-link-class" to="/NewsPage">
            <div style="float: right" class="newsbtn">MORE>></div>
          </router-link>
        </div>
        <div class="newstop" id="newstop">
          <div class="newstopL">
            <p class="newstopLp1">{{newstopLp1}}</p>
            <p class="newstopLp2">{{newstopLp2}}</p>
            <div class="newstopLp3">
              <router-link class="router-link-class"
                           :to="{ path: 'NewsPage/NewsinfoPage', query: { theInfoNum: newstopLpNum } }">
                <div class="theBtnC">
                  <div class="ckTB">查看全文</div>
                  <div class="arB">
                    <div class="tArL"></div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="newstopR" style="background-image: url('../static/resource/bgk1.png')">
            <img :src="newstoppic" alt=""/>
          </div>
        </div>
        <div>
          <div class="newsleft" id="newsleft">
            <div class="newsleftpic" style="background-image: url('../static/resource/bgk2.png')"><img :src="newsleftpic" alt=""/></div>
            <div class="newsleftword">
              <p class="newsleftwordp1">{{newsleftLp1}}</p>
              <p class="newsleftwordp2">{{newsleftLp2}}</p>
              <div class="newsleftwordp3">
                <router-link class="router-link-class"
                             :to="{ path: 'NewsPage/NewsinfoPage', query: { theInfoNum: newsleftLpNum } }">
                  <div class="theBtnC">
                    <div class="ckTB">查看全文</div>
                    <div class="arB">
                      <div class="tArL"></div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="newsright" id="newsright">
            <div class="newsrightpic" style="background-image: url('../static/resource/bgk2.png')"><img :src="newsrightpic" alt=""/></div>
            <div class="newsrightword">
              <span class="newsrightwords1">{{newsrightLp1}}</span>
              <span class="newsrightwords2">{{newsrightLp2}}</span>
              <div class="newsrightwordp3">
                <router-link class="router-link-class"
                             :to="{ path: 'NewsPage/NewsinfoPage', query: { theInfoNum: newsrightLpNum } }">
                  <div class="theBtnC">
                    <div class="ckTB">查看全文</div>
                    <div class="arB">
                      <div class="tArL"></div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 影视作品模块-->
      <div class="filmgraphyContent" v-show="ifShowfilmgraphy">
        <div class="filmgraphyTop">
          <img :src="filmgraphy" alt="" onerror="src='../static/resource/errorpic.png'"/>
        </div>
        <div class="filmgraphyContent" id="filmgraphyContent" onerror="src='../static/resource/errorpic.png'">
          <div class="filmGc1">
            <img :src="filmGc1pic1" alt="" class="filmGcPic" onerror="src='../static/resource/errorpic.png'"/>
            <img :src="filmGc1pic2" alt="" style="margin-top: 34px" class="filmGcPic"
                 onerror="src='../static/resource/errorpic.png'"/>
          </div>
          <div class="filmGc2">
            <img :src="filmGc2pic1" alt="" class="filmGcPic" onerror="src='../static/resource/errorpic.png'"/>
            <img :src="filmGc2pic2" alt="" style="margin-top: 34px" class="filmGcPic"
                 onerror="src='../static/resource/errorpic.png'"/>
          </div>
          <div class="filmGc3">
            <img :src="filmGc3pic1" alt="" class="filmGcPic" onerror="src='../static/resource/errorpic.png'"/>
            <router-link :to="{ path: 'FilmgraphyPage', query: { thebannernum: 2 } }">
              <img :src="filmpicturnto" alt="" style="margin-top: 34px" class="filmdetail"/>
            </router-link>
          </div>
        </div>
      </div>
      <!--合作艺人模块-->
      <div class="cooperationArtists">

        <img :src="coperpic" alt="" class="coperpic"/>
        <!-- 轮播-->
        <swiper :options="swiperOption1" ref="mySwiper" class="swiper-container-lunbo1" style="height: 380px">
          <!-- slides -->
          <swiper-slide v-for="item in cooperpicItems" style="width: 242px">
            <img v-for="items in item" :src="items.artistImg" alt="" class="coppic" @click="alertInfo(items.id)"
                 onerror="src='../static/resource/errorpic.png'"/>
            <div class="cooperBox">

            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"
               style="background-image: url('../static/resource/arrowLeft.png')"></div>
          <div class="swiper-button-next" slot="button-next"
               style="background-image: url('../static/resource/arrowRight.png')"></div>
        </swiper>
        <!--弹出框-->
        <div class="cooperalert" v-show="cpifshow">
          <div class="cooperalertBg"></div>
          <div class="cooperalertClose" @click="closeInfo()">X</div>
          <img :src="cooperalertimage" alt="" class="cooperalertimg" onerror="src='../static/resource/errorpic.png'"/>
          <div class="cooperalertinfo">
            <p class="coperinfop1" style="color: #74e4ff;font-size: 36px">{{thename}}</p>
            <div class="cooperalertinfobox">
              <p class="coperinfop2">{{theenglishname}}</p>
              <p class="coperinfop2">{{thebirthday}}</p>
              <p class="coperinfop2">{{theconstellation}}</p>
              <p class="coperinfop2">{{theheight}}</p>
              <p class="coperinfop2">{{theweight}}</p>
              <p class="coperinfop2">代表作品：</p>
              <p class="coperinfop3">{{theworks}}</p>
            </div>
          </div>
        </div>
      </div>
      <!--关于我们-->
      <div class="aboutUs">
        <div id="cooperPosion"></div>
        <div id="aboutPosion"></div>
        <img :src="aboutUsLogo" alt="" class="abpic"/>
        <div class="absContent">
          <img :src="aboutUsOne" alt="" class="absborderimg"/>
          <div class="abstext" :style="'background:url(' + tabstextbgimg + ');background-size: cover'">
            <p style="text-indent: 2em" >
              北京萌样影视制作有限公司成立于2015年，是一家朝气蓬勃发展迅猛的新晋影视文化传媒公司，主要从事影视IP开发与策划、影视剧制作与拍摄、艺人经纪与宣传、商务合作与拓展，设有制作部、经纪部、宣传部、商务部等专业部门。凭借众多优质ip资源，优秀的青年编剧团队，品类繁多的商务合作对象，全媒体资源的宣传推广，优质的新生代偶像以及专业的艺人课程培训，打造以“优质IP”为核心的良好影视娱乐生态圈。</p>
            <p style="text-indent: 2em;margin-bottom: 10px">
              自成立以来，在公司总裁，业内资深制作人、出品人、经纪人柴智屏的带领下，策划制作并参与投资拍摄了青春题材影片《三好差生》《有五个姐姐的我就注定要单身了啊》《别那么骄傲》以及超级IP《流星花园》；同时与国内各大知名影视公司、演员工作室均建立了良好的合作关系，逐渐在业内获得了一定的口碑和影响力。</p>
          </div>
          <div class="abspeople2" @click="aboutusalert(1)">
            <img :src="aboutUsTwo" alt="" class=""/>
            <img :src="aboutUsThree" alt="" class="abspeople2Cover"/>
          </div>
          <div class="abspeople1" @click="aboutusalert(0)">
            <img :src="aboutUsFour" alt="" class=""/>
            <img :src="aboutUsFive" alt="" class="abspeople1Cover"/>
          </div>
          <div class="abspeople3" @click="aboutusalert(2)">
            <img :src="aboutUsSix" alt="" class=""/>
            <img :src="aboutUsSeven" alt="" class="abspeople3Cover"/>
          </div>
        </div>
        <!--弹出框-->
        <div class="aboutUsalert" v-show="auifshow">
          <div class="aboutUsalertBg" :class="{ 'aubgActive1' : select1 == 0 }"></div>
          <div class="aboutUsalertClose" @click="aboutUsalertClose">X</div>
          <img :src="abtuspic" alt="" class="aboutUsalertimg"/>
          <div class="aboutUsalertinfo">
            <p class="absinfop1">{{name}}</p>
            <p class="absinfop2">{{place}}</p>
            <p class="absinfop3">{{intro1}}</p>
            <p class="absinfop3">{{intro2}}</p>
            <p class="absinfop3">{{intro3}}</p>
          </div>
        </div>
      </div>
      <!--合作伙伴-->
      <div class="partner">
        <div class="partnerdiv">
          <p>合作伙伴</p>
          <p>COOPERRATICE PARTNER</p>
        </div>
        <div class="partnerpicbox">
          <img v-for="item in cmP" :src="item" class="partnerpic">
        </div>
      </div>
      <!--联系我们地址-->
      <div class="contactusbox">
        <div class="showbiggermap" v-show="ifshowbiggermap">
          <div></div>
          <themap id="mapcontainer"></themap>
          <div class="contactusClose" @click="contactusClose">X</div>
        </div>
        <!--主题内容-->
        <img :src="contactustop">
        <div class="contactuscontent">
          <div style="font-family:'Microsoft YaHei';">
            <p class="contactusPn">公司地址 :</p>
            <p class="contactusPc">北京市朝阳区大望路3号院3号楼1606室</p>
            <p class="contactusPn">联系电话 :</p>
            <p class="contactusPc">010-85999059</p>
            <p class="contactusPn">联系邮箱 :</p>
            <p class="contactusPc">446837173@qq.com</p>
          </div>
          <div v-on:mouseenter="showbigger" v-on:mouseleave="hidebigger">
            <img :src="themap" onerror="src='../static/resource/errorpic.png'" v-on:mouseup="upbigger">
            <img :src="bigger" class="bigger" v-if="ifbiggershow" v-on:mousedown="downbigger" v-on:mouseup="upbigger"
                 :class="{ activebigger: isactivebigger }">
          </div>
        </div>
      </div>
      <div class="bottomconw">
        <span> Copyright @ 2018-2028 all rights reserved 北京萌样影视制作有限公司 版权所有</span><br><br>
        <span>京ICP备18023946号-1</span>
      </div>
    </div>
  </div>
</template>
<script>
  import Request from '../common/request.js';
  import themap from '@/components/BDMap'

  var _this;
  var request = new Request();
  var cmpic = ['../static/resource/cm1.png', '../static/resource/cm2.png', '../static/resource/cm3.png', '../static/resource/cm4.png'];
  var arrfilm = [];
  var arrModel = []
  var b1 = {
    pic: "../static/resource/absinfoimg1.png",
    name: '崔震东',
    place: '北京萌样影视制作有限公司首席执行官',
    intro1: '崔震东，知名制片人、出品人、导演。曾任索尼音乐大中华区总裁，期间成功打造了周杰伦、王力宏、蔡依林等华语歌坛天王天后，是在台湾娱乐媒体中战功彪炳的标志性人物。',
    intro2: '过去五年来，担任青春爱情电影《小时代》以及《等一个人咖啡》制片人并于2016年首度执导惊悚电影《楼下的房客》成功入围第53届台湾电影金马奖最佳视觉效果奖，2017年更是亲自参与公司重点项目—偶像剧《流星花园》。',
    intro3: '崔震东凭借其多年的商业嗅觉及优质的资源定将为公司带来更广阔的发展机会。'
  }
  var b2 = {
    pic: "../static/resource/absinfoimg2.png",
    name: '柴智屏',
    place: '北京萌样影视制作有限公司总裁',
    intro1: '柴智屏，资深制作人、出品人、经纪人，从业二十余年，2001年凭借《流星花园》的超高收视率缔造了一场偶像剧神话，开创了一个华语影视圈的新纪元，并一手捧红了华人偶像团体F4，是台湾偶像剧教母级的人物；2011年，制作的电影《那些年我们一起追的女孩》获得了两岸三地以及东南亚地区14亿新台币的票房肯定同时也取得了第31届金像奖最佳两岸华语电影大奖的肯定，更是自此掀起了青春校园片的潮流；2013年，获选两岸十大亮点人物之一，是所有当选者中唯一的女性；2017年，担任新版《流星花园》总制片人甚至亲自执导，重启经典，以更成熟的故事和制作迎接市场和观众的考验，再造神话。',
    intro2: '过去五年来，担任青春爱情电影《小时代》以及《等一个人咖啡》制片人并于2016年首度执导惊悚电影《楼下的房客》成功入围第53届台湾电影金马奖最佳视觉效果奖，2017年更是亲自参与公司重点项目—偶像剧《流星花园》。',
    intro3: '柴智屏以她独到的眼光和对细节的要求，精准洞悉市场，把控优质 项目，带领公司稳步发展壮大。'
  }
  var b3 = {
    pic: "../static/resource/absinfoimg3.png",
    name: '吕小佳',
    place: '北京萌样影视制作有限公司总经理',
    intro1: '吕小佳，制片人、经纪人，从业十余年，以市场和观众为基础，深耕影视剧市场，积累了丰富的项目经验。2013-2015年，担任《小时代》系列影片的出品人，全系列票房超二十亿，成功抓住了年轻受众引爆票房引爆市场；2014年制作的的都市情缘偶像剧《美妙的情缘》成功登陆央八黄金档；同时通过不断的项目积累，使其对新人的挖掘和艺人的影视发展具有精准的市场眼光；2017年担任《流星花园》制片人，依托于项目挖掘了超世代偶像团体F4及新生代小花董馨，使其在剧中大放异彩；2016年至今，她积极拓展公司艺人宋芸桦，林妍柔，禾浩辰经纪业务，近两年也均有不俗的成绩。',
    intro2: '吕小佳以她对多个成熟项目的把控以及对公司事务全面而不失细节的关注，在公司不断发展壮大的道路上建立起了一道坚实的安全屏障。'
  }
  var arrbmodel = [];
  arrbmodel.push(b1);
  arrbmodel.push(b2);
  arrbmodel.push(b3);
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: 'FirstPage',
    data: function () {
      return {
        turnToLink: '/NewsPage/NewsinfoPage',
        swiperOption: {
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: false,//修改swiper的父元素时，自动初始化swiper
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-container-lunbo>.swiper-button-next',
            prevEl: '.swiper-container-lunbo>.swiper-button-prev'
          }
        },
        picItems: [],
        swiperOption1: {
          slidesPerView: 1,
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: false,//修改swiper的父元素时，自动初始化swiper
          speed: 300,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-container-lunbo1>.swiper-button-next',
            prevEl: '.swiper-container-lunbo1>.swiper-button-prev'
          }
        },
        ifShowNews: false,
        newstitlepic: '../static/resource/news.png',
        newslookalltxt: '../static/resource/newslookalltxt.png',
//        新闻资讯数据
        newstopLp1: '',
        newstopLp2: '',
        newstoppic: '',
        newsleftLp1: '',
        newsleftLp2: '',
        newsleftpic: ' ',
        newsrightLp1: '',
        newsrightLp2: '',
        newsrightpic: '',
//        影视作品数据
        ifShowfilmgraphy: false,
        filmgraphy: '../static/resource/filmgraphy.png',
        filmGc1pic1: '',
        filmGc1pic2: '',
        filmGc2pic1: '',
        filmGc2pic2: '',
        filmGc3pic1: '',
        filmpicturnto: '../static/resource/filmpic6.png',
        coperpic: '../static/resource/coperpic.png',
        cooperpicItems: [],
//      关于我们数据
        aboutUsLogo: '../static/resource/aboutus.png',
        aboutUsOne: '../static/resource/absborder.png',
        aboutUsTwo: '../static/resource/P2.png',
        aboutUsThree: '../static/resource/selectedpic.png',
        aboutUsFour: '../static/resource/p1.png',
        aboutUsFive: '../static/resource/selectedpic.png',
        aboutUsSix: '../static/resource/p3.png',
        aboutUsSeven: '../static/resource/selectedpic.png',
        tabstextbgimg: '../static/resource/absbg.png',
        partnerpic: '',
        contactuspic: '../static/resource/contactus.png',
        cpifshow: false,
        thename: '',
        theenglishname: '',
        thebirthday: '',
        theconstellation: '',
        theheight: '',
        theweight: '',
        theworks: '',
        cooperalertimage: '',
        arr: arrModel,
        arraboutus: arrbmodel,
        auifshow: false,
        name: '',
        place: '',
        intro1: '',
        intro2: '',
        intro3: '',
        abtuspic: '',
        select1: 1,
        cmP: cmpic,
        contactustop: '../static/resource/contactustop.png',
        themap: '../static/resource/themap.png',
        bigger: '../static/resource/bigger.png',
        ifbiggershow: false,
        isactivebigger: false,
        showbiggermapimg: '../static/resource/themapbigger.png',
        ifshowbiggermap: false,
        newstopLpNum: 0,
        newsleftLpNum: 0,
        newsrightLpNum: 0,
        thebannerNum1: 1,
      }
    },
    methods: {
      ifturntonewpage: function (num, hashLinkNum, lUrl) {
        console.log(num)
        // hashLinkNum   0无连接  1外链  2内链
        if (hashLinkNum == 1) {
          window.open(lUrl)
        }
        if (hashLinkNum == 2) {
          _this.$router.push({path: 'NewsPage/NewsinfoPage', query: {theInfoNum: lUrl.split('id=')[1]}})
        }
      },
      //首页合作艺人接口
      alertInfo: function (index) {
        request.get({
          url: '/mengyang/artist/loadArtist',
          params: {
            id: index
          },
          callback(data) {
            var xz;
            var xzw;
            _this.cooperalertimage = data.data[0].artistImg;
            _this.thename = data.data[0].name;
            data.data[0].englishName == undefined ? _this.theenglishname = '英文 : ' + '未知' : _this.theenglishname = '英文 : ' + data.data[0].englishName;
            data.data[0].birthdayStr == undefined ? _this.thebirthday = '生日 : ' + '未知' : _this.thebirthday = '生日 : ' + data.data[0].birthdayStr;
            data.data[0].birthdayStr != undefined ? xz = Number(data.data[0].birthdayStr.split('-')[1] + '.' + data.data[0].birthdayStr.split('-')[2]) : xz = '未知';
            if (xz >= 3.21 && xz <= 4.19) {
              xzw = '白羊座';
            } else if (xz >= 4.20 && xz <= 5.20) {
              xzw = '金牛座';
            } else if (xz >= 5.21 && xz <= 6.21) {
              xzw = '双子座';
            } else if (xz >= 6.22 && xz <= 7.22) {
              xzw = '巨蟹座';
            } else if (xz >= 7.23 && xz <= 8.22) {
              xzw = '狮子座';
            } else if (xz >= 8.23 && xz <= 9.22) {
              xzw = '处女座';
            } else if (xz >= 9.23 && xz <= 10.23) {
              xzw = '天秤座';
            } else if (xz >= 10.24 && xz <= 11.22) {
              xzw = '天蝎座';
            } else if (xz >= 11.23 && xz <= 12.21) {
              xzw = '射手座';
            } else if (xz >= 12.22 && xz <= 12.31 || xz >= 1.01 && xz <= 1.19) {
              xzw = '摩羯座';
            } else if (xz >= 1.20 && xz <= 2.18) {
              xzw = '水平座';
            } else if (xz >= 4.20 && xz <= 5.20) {
              xzw = '金牛座';
            } else if (xz >= 2.19 && xz <= 3.20) {
              xzw = '双鱼座';
            } else {
              xzw = '未知'
            }
            _this.theconstellation = '星座 : ' + xzw;
            data.data[0].height == undefined ? _this.theheight = '身高 : ' + '未知' : _this.theheight = '身高 : ' + data.data[0].height;
            data.data[0].weight == undefined ? _this.theweight = '体重 : ' + '未知' : _this.theweight = '体重 : ' + data.data[0].weight;
            data.data[0].production == undefined ? _this.theworks = '未知' : _this.theworks = data.data[0].production;
            _this.cpifshow = true;
          }
        })
      },
      closeInfo: function () {
        this.cpifshow = false;
      },
      aboutusalert: function (index) {
        this.abtuspic = arrbmodel[index].pic;
        this.name = arrbmodel[index].name;
        this.place = arrbmodel[index].place;
        this.intro1 = arrbmodel[index].intro1;
        this.intro2 = arrbmodel[index].intro2;
        this.intro3 = arrbmodel[index].intro3;
        this.auifshow = true;
      },
      aboutUsalertClose: function () {
        this.auifshow = false;
      },
      showbigger: function () {
        this.ifbiggershow = true;
      },
      hidebigger: function () {
        this.ifbiggershow = false;
      },
      downbigger: function () {
        this.isactivebigger = true;
      },
      upbigger: function () {
        this.isactivebigger = false;
        this.ifshowbiggermap = true;
      },
      contactusClose: function () {
        this.ifshowbiggermap = false;
      }
    },
    components: {
      themap
    },
    mounted: function () {
      _this = this;
    },
    //-----------------------------ajax获取数据-----------------------
    created: function () {
      //页面轮播图片
      request.get({
        url: '/mengyang/advert/getPortalAdverts',
        callback(data) {
          if (data.code != 1) {
            data.data.forEach(function (ele) {
              _this.picItems.push({img: ele.advertImg, id: ele.id, hL: ele.hasLink, lU: ele.linkUrl})
            })
          }
        }
      })
      //首页三条资讯热点请求数据
      request.get({
        url: '/mengyang/information/getPortalInformations',
        callback(data) {
          console.log(data)
          try {
          if (data.code == 1) {
            _this.ifShowNews = false;
          } else {
            var thenewsArr = []
            if (data.code == 0) {
              if (data.data.length >= 3) {
                _this.ifShowNews = true;
              }

              var tempmesarr={};
              tempmesarr.length=3;
             for(var t=0;t<data.data.length;t++){
               if( data.data[t].position==0){
                 tempmesarr[0]=data.data[t]
                 console.log(0)
               }
               if( data.data[t].position==1){
                 tempmesarr[1]=data.data[t]
                 console.log(1)
               }
               if( data.data[t].position==2){
                 tempmesarr[2]=data.data[t]
                 console.log(2)
               }
             }
              for (var i = 0; i < 3; i++) {
                if (!tempmesarr[i]) {
                  thenewsArr[i] = ''
                } else {
                  if (undefined == tempmesarr[i].viewImg) {
                    thenewsArr[i] = ''
                  } else {
                    thenewsArr[i] = tempmesarr[i].viewImg
                  }
                }
              }
              try {
                tempmesarr[0].name.length > 30 ? _this.newstopLp1 = tempmesarr[0].name.substring(0, 30) + '...' : _this.newstopLp1 = tempmesarr[0].name;
                tempmesarr[0].summary.length > 70 ? _this.newstopLp2 = tempmesarr[0].summary.substring(0, 70) + '...' : _this.newstopLp2 = tempmesarr[0].summary;
                _this.newstoppic = thenewsArr[0];
                _this.newstopLpNum = tempmesarr[0].id;
              }catch (e) {}
              try {
                tempmesarr[1].name.length > 20 ? _this.newsleftLp1 = tempmesarr[1].name.substring(0, 20) + '...' : _this.newsleftLp1 = tempmesarr[1].name;
                tempmesarr[1].summary.length > 70 ? _this.newsleftLp2 = tempmesarr[1].summary.substring(0, 70) + '...' : _this.newsleftLp2 = tempmesarr[1].summary;
                _this.newsleftpic = thenewsArr[1];
                _this.newsleftLpNum = tempmesarr[1].id;
              }catch (e) {}
              try {
                tempmesarr[2].name.length > 20 ? _this.newsrightLp1 = tempmesarr[2].name.substring(0, 20) + '...' : _this.newsrightLp1 = tempmesarr[2].name;
                tempmesarr[2].summary.length > 70 ? _this.newsrightLp2 = tempmesarr[2].summary.substring(0, 70) + '...' : _this.newsrightLp2 = tempmesarr[2].summary;
                _this.newsrightpic = thenewsArr[2];
                _this.newsrightLpNum = tempmesarr[2].id;
              }catch (e) {}

            }
          }
        }catch (e) {

          }
        }
      })
      //首页影视作品接口
      request.get({
        url: '/mengyang/film/getPortalFilms',
        params: {},
        callback(data) {
          var thefilmArr = []
          if (data.code != 1) {
            if (data.data.length >= 1) {
              _this.ifShowfilmgraphy = true;
            }
            for (var u = 0; u < 5; u++) {
              if (!data.data[u]) {
                thefilmArr[u] = ''
              } else {
                undefined == data.data[u].filemImg ? thefilmArr[u] = '' : thefilmArr[u] = data.data[u].filemImg;
              }
            }
            _this.filmGc1pic1 = thefilmArr[0];
            _this.filmGc1pic2 = thefilmArr[3];
            _this.filmGc2pic1 = thefilmArr[1];
            _this.filmGc2pic2 = thefilmArr[4];
            _this.filmGc3pic1 = thefilmArr[2];
          }
        }
      })
      //首页合作艺人接口
      request.get({
        url: '/mengyang/artist/getPortalArtists',
        params: {},
        callback(data) {
          if (data.code == 1 || data.data.length == 0) {
          } else {
            var thecooperArr = []
            if (data.code != 1) {
              for (var y = 0; y < data.data.length; y++) {
                if (data.data[y].artistImg != undefined) {
                  thecooperArr.push(data.data[y])
                }
              }
            }
            var newthecooperArr = [];
            var tempnum = thecooperArr.length / 4;
            for (var t = 0; t < Math.ceil(tempnum); t++) {
              newthecooperArr[t] = []
              for (var r = 0; r < 4; r++) {
                if (thecooperArr[(4 * t + r)] == undefined) {
                  break;
                } else {
                  newthecooperArr[t].push(thecooperArr[(4 * t + r)])
                }
              }
            }
            _this.cooperpicItems = newthecooperArr;
          }
        }
      })
    }

  }
</script>

<style>
  .swiper-container-lunbo {
    width: auto;
    min-width: 1204px;
    max-width: 1920px;
    max-height: 700px;
  }

  .swiper-container-lunbo img {
    cursor: pointer;
  }
  .swiper-container-lunbo .swiper-pagination-bullet {
    border-radius: 0 !important;
    width: 76px !important;
  }

  .swiper-container-lunbo1 .swiper-pagination-bullet {
    border-radius: 0 !important;
    width: 76px !important;
  }

  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 14px !important;
  }

  .swiper-container-lunbo1 .swiper-slide {
    width: 242px;
  }

  .content {
    width: 1204px;
    height: auto;
    margin: 0 auto;
  }

  .news {
    box-sizing: border-box;
    padding: 36px;
    width: 100%;
    height: 820px;
    background: #f6f6f6;
  }

  .newspo {
    font-size: 28px;
  }

  .newspt {
    font-size: 18px;
    padding-bottom: 10px;
    color: #999999;
  }

  .newsbtn {
    font-size: 24px;
    color: #71e5fa;
    cursor: pointer;
  }

  .newsbtn:hover {
    color: #17bfdd;
  }

  .newstop {
    width: 1128px;
    height: 324px;
    background: white;
    overflow: hidden;
  }

  .newstopL {
    height: auto;
    width: 460px;
    margin-left: 44px;
    float: left;
  }

  .newstopLp1 {
    padding-top: 44px;
    color: #000000;
    font-size: 26px;
    width: 490px;
    height: 74px;
    word-break:break-all;
    overflow: hidden;
  }

  .newstopLp2 {
    margin-top: 22px;
    color: #969696;
    font-size: 18px;
    width: 458px;
    height: 70px;
    word-break:break-all;
    overflow: hidden;
  }

  .newstopLp3 {
    width: 148px;
    margin-top: 22px;
    padding-bottom: 38px;
  }

  .newstopR {
    position: relative;
    margin-top: 20px;
    box-sizing: border-box;
    float: left;
    height: 274px;
    width: 416px;
    margin-left: 132px;
    padding-bottom: 20px;
    padding-top: 12px;
  }

  .newstopR > img {
    position: absolute;
    top: 10px;
    left: 10px;
    height: 274px;
    width: 416px;
  }

  .newsleft {
    height: 300px;
    width: 554px;
    background: white;
    float: left;
    margin-top: 21px;
  }

  .newsright {
    height: 300px;
    width: 554px;
    background: white;
    float: left;
    margin-top: 21px;
    margin-left: 21px;
  }

  .newsleftpic {
    position: relative;
    width: 185px;
    height: 260px;
    margin-left: 40px;
    margin-top: 18px;
    float: left;
  }

  .newsleftpic > img {
    position: absolute;
    top: -10px;
    left: -10px;
    width: 185px;
    height: 260px;
    border: none;
  }

  .newsleftword {
    float: left;
    margin-left: 12px;;
  }

  .newsleftwordp1 {
    margin-top: 38px;
    width: 276px;
    height: 58px;
    font-size: 22px;
    color: #000000;
    word-break:break-all;
    overflow: hidden;
  }

  .newsleftwordp2 {
    padding-top: 10px;
    color: #969696;
    font-size: 18px;
    width: 284px;
    height: 132px;
    word-break:break-all;
  }

  .newsleftwordp3 {
    width: 150px;
    margin-top: 0px;
    margin-left: 130px;
  }

  .newsrightwordp3 {
    width: 150px;
    margin-left: 130px;
    margin-top: 0px;
  }

  .newsrightpic {
    position: relative;
    width: 185px;
    height: 260px;
    margin-left: 16px;
    margin-top: 18px;
    float: left;
  }

  .newsrightpic > img {
    position: absolute;
    top: -10px;
    left: -10px;
    width: 185px;
    height: 260px;
  }

  .newsrightword {
    margin-left: 12px;
    margin-top: 38px;
    float: left;
    height: 200px;
    width: 296px;;
  }

  .newsrightwords1 {
    display: block;
    width: 296px;
    height: 58px;
    font-size: 22px;
    color: #000000;
    word-break:break-all;
    overflow: hidden;
  }

  .newsrightwords2 {
    padding-top: 10px;
    display: block;
    width: 284px;
    height: 132px;
    font-size: 18px;
    color: #969696;
    word-break:break-all;
    overflow: hidden;
  }

  .filmgraphyContent {
    position: relative;
    width: 100%;
    height: 1320px;
  }

  .filmgraphyTop img {
    height: 88px;;
  }

  #filmgraphyContent img:hover {
    cursor: pointer;
    box-shadow: 0px 0px 14px #e2e2e2;
  }

  .filmGc1 {
    width: 379px;
    height: 1094px;
    float: left;
    margin-top: 40px;
  }

  .filmGc1 img {
    width: 379px;
    height: 532px;
  }

  .filmGc2 {
    width: 376px;
    height: 1094px;
    float: left;
    margin-left: 34px;
  }

  .filmGc2 img {
    width: 376px;
    height: 532px;
  }

  .filmGc3 {
    width: 379px;
    height: 1094px;
    float: left;
    margin-left: 34px;
    margin-top: 94px;
  }

  .filmGc3 img {
    width: 379px;
    height: 532px;
  }

  .filmdetail {
    cursor: pointer;
  }

  .cooperationArtists {
    position: relative;
    height: 466px;
    width: 1204px;
    background: #f6f6f6;
    margin-top: 46px;
  }

  .coperpic {
    height: 88px;
  }

  .cooperBox {
    width: 1000px;
    height: 340px;
    padding-left: 100px;
    color: red;
  }

  .coppic {
    margin-left: 50px;
    float: left;
    cursor: pointer;
    height: 340px;
    width: 240px;
  }

  .swiper-container-lunbo1 img {
    width: 240px;
    height: 340px;
  }

  .aboutUs {
    position: relative;
    margin-top: 40px;
  }

  #aboutPosion {
    position: absolute;
    top: -34px;
    height: 1px;
    width: 1px;
    background: black;
  }

  #cooperPosion {
    position: absolute;
    top: -564px;
    height: 1px;
    width: 1px;
    background: white;
  }

  .abpic {
    height: 88px;
  }

  .absContent {
    width: 100%;
    height: 224px;
    position: relative;
  }

  .absborderimg {
    width: 1116px;
    height: 224px;
    float: right;
  }

  .abstext {
    position: absolute;
    top: 18px;
  }
  .abstext{
    width: 684px;
  }
  .abstext p {
    width: 550px;
    margin-top: 28px;
    margin-left: 54px;
    margin-right: 30px;
    font-weight: bold;
    font-size: 18px;
  }

  .abspeople1 {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 124px;
    left: 700px;
    cursor: pointer;
  }

  .abspeople1 img:first-child {
    width: 200px;
    height: 200px;
  }

  .abspeople1Cover {
    position: absolute;
    top: 0px;
    left: 100px;
    width: 0px;
    height: 138px;
    opacity: 0;
    transition: .3s;
  }

  .abspeople1:hover .abspeople1Cover {
    opacity: 0.5;
    left: 0px;
    width: 200px;
  }

  .abspeople2 {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 0px;
    left: 822px;
    cursor: pointer;
  }

  .abspeople2 img:first-child {
    width: 200px;
    height: 200px;
  }

  .abspeople2Cover {
    position: absolute;
    top: 0px;
    left: 100px;
    width: 0px;
    height: 138px;
    opacity: 0;
    transition: .3s;
  }

  .abspeople2:hover .abspeople2Cover {
    opacity: 0.5;
    left: 0px;
    width: 200px;
  }

  .abspeople3 {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 124px;
    left: 950px;
    cursor: pointer;
  }

  .abspeople3 img:first-child {
    width: 200px;
    height: 200px;
  }

  .abspeople3Cover {
    position: absolute;
    top: 0px;
    left: 100px;
    width: 0px;
    height: 138px;
    opacity: 0;
    transition: .3s;
  }

  .abspeople3:hover .abspeople3Cover {
    opacity: 0.5;
    width: 200px;
    left: 0px;
  }

  .aboutUsalert {
    position: absolute;
    top: 20px;
    left: 90px;
    width: 1030px;
    height: 470px;
    z-index: 100;

  }

  .aboutUsalertClose {
    position: absolute;
    font-size: 34px;
    font-weight: bolder;
    top: 14px;
    left: 980px;
    color: white;
    cursor: pointer;
  }

  .aboutUsalertClose:hover {
    top: 9px;
    left: 975px;
    font-size: 44px;
  }

  .aboutUsalertBg {
    width: 1030px;
    height: 700px;
    background: black;
    opacity: 0.9;
  }

  .aboutUsalertimg {
    width: 316px;
    height: 420px;
    position: absolute;
    top: 138px;
    left: 22px;
  }

  .aboutUsalertinfo {
    color: white;
    position: absolute;
    top: 40px;
    left: 380px;;
    height: 404px;
  }

  .absinfop1 {
    color: #74e4ff;
    font-size: 36px;
    font-family: "Microsoft YaHei";
    margin-bottom: 30px;
  }

  .absinfop2 {
    color: #ffffff;
    font-size: 24px;
    font-family: "Microsoft YaHei";
    margin-bottom: 34px;;
  }

  .absinfop3 {
    color: #ffffff;
    font-size: 22px;
    font-family: "Microsoft YaHei";
    text-indent: 2em;
    width: 615px;
  }

  .theBottom {
    position: fixed;
    bottom: -1px;
    height: 40px;
    width: 100%;
    background: #282828;
    z-index: 100;
  }

  .theBottom img {
    height: 40px;
  }

  .cooperalert {
    position: absolute;
    top: 20px;
    left: 90px;
    width: 1030px;
    height: 470px;
    z-index: 100;
    /*display: none;*/
  }

  .cooperalertClose {
    position: absolute;
    font-size: 34px;
    font-weight: bolder;
    top: 14px;
    left: 980px;
    color: white;
    cursor: pointer;
  }

  .cooperalertClose:hover {
    top: 9px;
    left: 975px;
    font-size: 44px;
  }

  .cooperalertBg {
    width: 1030px;
    height: 470px;
    background: black;
    opacity: 0.9;
  }

  .cooperalertimg {
    width: 316px;
    height: 420px;
    position: absolute;
    top: 24px;
    left: 22px;
  }

  .cooperalertinfo {
    color: white;
    position: absolute;
    top: 40px;
    left: 380px;;
  }

  .coperinfop1 {
    height: 47px;
    width: 590px;
    color: #74e4ff;
    font-size: 36px;
    font-family: "Microsoft YaHei";
    margin-bottom: 30px;
  }

  .cooperalertinfobox {
    height: 328px;
    width: 638px;
    overflow: auto;
  }

  .coperinfop2 {
    height: 29px;
    width: 450px;
    color: #FFFFFF;
    font-size: 22px;
    font-family: "Microsoft YaHei";
    margin-top: 16px;
  }

  .coperinfop3 {
    width: 620px;
    color: #FFFFFF;
    font-size: 22px;
    font-family: "Microsoft YaHei";
    margin-top: 0px;
  }

  .coperinfop1 {
    width: 638px;
    color: #FFFFFF;
    font-size: 22px;
    font-family: "Microsoft YaHei";
    margin-top: 16px;
  }

  .partner {
    margin-top: 180px;
    background-color: #f6f6f6;
    width: 1204px;

  }

  .partnerdiv {
    height: 140px;
    width: 1204px;
    text-align: center;
  }

  .partner p:nth-child(1) {
    padding-top: 40px;
    font-size: 36px;
  }

  .partner p:nth-child(2) {
    margin-top: 14px;
    font-size: 14px;
    color: #8f8f8f;
  }

  .partnerpicbox {
    clear: both;
    width: 1204px;
    height: auto;
    text-align: center;
    padding-bottom: 36px;
  }

  .partnerpic {
    width: 240px;
    height: 74px;
    display: inline-block;
    margin-right: 11px;
    margin-left: 11px;
  }

  .contactusbox {
    width: 1204px;
    border-bottom: 4px solid #f0f0f0;
    padding-bottom: 60px;
    margin-bottom: 46px;
  }
  .bottomconw{
    color: #999;
    width: 1204px;
    font-size: 14px;
    text-align: center;
  }
  .contactuscontent {
    width: 1204px;
    height: 412px;
    margin-top: 6px;
  }

  .contactuscontent > div {
    height: 412px;
    width: 50%;
    float: left;
  }

  .contactuscontent > div:nth-child(1) {
    box-sizing: border-box;
    padding-left: 36px;
    padding-top: 40px;
  }

  .contactusPn {
    font-family: 'Microsoft YaHei';
    font-size: 26px;
    margin-top: 44px;
  }

  .contactusPc {
    font-family: 'Microsoft YaHei';
    font-size: 22px;
    margin-top: 20px;
  }

  .contactuscontent > div:nth-child(2) {
    cursor: pointer;
    position: relative;
  }

  .contactuscontent > div:nth-child(2) > img:nth-child(1) {
    height: 412px;
    width: 100%;
  }

  .bigger {
    height: 38px;
    width: 38px;
    position: absolute;
    top: 0;
    left: 602px;
  }

  .activebigger {
    height: 40px;
    width: 40px;
    position: absolute;
    top: -1px;
    left: 601px;
  }

  .showbiggermap {
    position: absolute;
    width: 1204px;
    height: 616px;
    z-index: 100;
    overflow: hidden;
  }

  .showbiggermap > div:nth-child(1) {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.8;
  }

  .showbiggermap > img {
    position: absolute;
    width: 90%;
    height: 90%;
    top: 5%;
    left: 5%;
    /*cursor: pointer;*/
  }

  #mapcontainer {
    position: absolute;
    width: 90%;
    height: 90%;
    top: 5%;
    left: 5%;
  }

  .contactusClose {
    position: absolute;
    font-size: 34px;
    font-weight: bolder;
    top: 14px;
    left: 1164px;
    color: white;
    cursor: pointer;
  }

  .contactusClose:hover {
    top: 9px;
    left: 1160px;
    font-size: 44px;
  }

  /*查看按钮*/
  .theBtnC {
    height: 40px;
    width: 148px;
    border: 1px solid black;
    border-radius: 50px;
    font-size: 16px;
    line-height: 40px;
    cursor: pointer;
  }

  .ckTB {
    display: inline-block;
    float: left;
    margin-left: 16px;
  }

  .arB {
    display: inline-block;
    float: left;
    margin-left: 28px;
    margin-top: 6px;
    height: 26px;
    width: 26px;
    border: 1px solid black;
    border-radius: 50%;
  }

  .tArL {
    margin-left: 8px;
    margin-top: 7px;
    height: 8px;
    width: 8px;
    border: 1px solid;
    border-color: #ffffff #000 #000 #ffffff;
    transform-origin: 50% 50%;
    transform: rotate(45deg);
    transition: .1s;
  }

  .theBtnC:hover .tArL {
    border: 2px solid;
    border-color: #ffffff #000 #000 #ffffff;
    transform-origin: 50% 50%;
    transform: rotate(-45deg);
  }

  .theBtnC:hover .arB {
    border: 2px solid black;
    margin-left: 27px;
    margin-top: 5px;
  }

  .theBtnC:hover .ckTB {
    color: black;
  }

  .swiper-pagination-bullet-active {
    background: #75e3ff;
  }

  .swiper-pagination .swiper-pagination-clickable .swiper-pagination-bullets {
    margin-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/firstPage.vue